// "Assumptions and warnings" (ticket 072, W11): the estimate's caveats, closed by default.
// Intake clients only for now. A native <details> element, so nothing to keep in state.
import React from 'react'

export function CaveatsSection({ caveats }) {
  if (!caveats || caveats.length === 0) return null
  return (
    <details className="brief-section brief-caveats">
      <summary className="brief-section-header brief-caveats-summary">
        <span className="brief-section-title">Assumptions and warnings</span>
      </summary>
      <div className="brief-section-body">
        <ul className="brief-fact-list">
          {caveats.map((c) => <li key={c}>{c}</li>)}
        </ul>
      </div>
    </details>
  )
}
